export default __webpack_public_path__ + "static/commmune-community-touch-f53da1b7ea2b4246bbc41a98d6d2d1b6.png";